/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DiscreteNumericListDto } from './DiscreteNumericListDto';
import {
    instanceOfDiscreteNumericListDto,
    DiscreteNumericListDtoFromJSON,
    DiscreteNumericListDtoFromJSONTyped,
    DiscreteNumericListDtoToJSON,
} from './DiscreteNumericListDto';
import type { DiscreteNumericValueDto } from './DiscreteNumericValueDto';
import {
    instanceOfDiscreteNumericValueDto,
    DiscreteNumericValueDtoFromJSON,
    DiscreteNumericValueDtoFromJSONTyped,
    DiscreteNumericValueDtoToJSON,
} from './DiscreteNumericValueDto';
import type { EnumerationValueDto } from './EnumerationValueDto';
import {
    instanceOfEnumerationValueDto,
    EnumerationValueDtoFromJSON,
    EnumerationValueDtoFromJSONTyped,
    EnumerationValueDtoToJSON,
} from './EnumerationValueDto';
import type { EnumerationValueListDto } from './EnumerationValueListDto';
import {
    instanceOfEnumerationValueListDto,
    EnumerationValueListDtoFromJSON,
    EnumerationValueListDtoFromJSONTyped,
    EnumerationValueListDtoToJSON,
} from './EnumerationValueListDto';
import type { FaultyNumericValueDto } from './FaultyNumericValueDto';
import {
    instanceOfFaultyNumericValueDto,
    FaultyNumericValueDtoFromJSON,
    FaultyNumericValueDtoFromJSONTyped,
    FaultyNumericValueDtoToJSON,
} from './FaultyNumericValueDto';
import type { NumericListDto } from './NumericListDto';
import {
    instanceOfNumericListDto,
    NumericListDtoFromJSON,
    NumericListDtoFromJSONTyped,
    NumericListDtoToJSON,
} from './NumericListDto';
import type { NumericValueDto } from './NumericValueDto';
import {
    instanceOfNumericValueDto,
    NumericValueDtoFromJSON,
    NumericValueDtoFromJSONTyped,
    NumericValueDtoToJSON,
} from './NumericValueDto';
import type { TextValueDto } from './TextValueDto';
import {
    instanceOfTextValueDto,
    TextValueDtoFromJSON,
    TextValueDtoFromJSONTyped,
    TextValueDtoToJSON,
} from './TextValueDto';

/**
 * @type ISingleSystemSetupParameter
 * 
 * @export
 */
export type ISingleSystemSetupParameter = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & EnumerationValueDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } & EnumerationValueListDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DiscreteNumericListDto, Ptw.Ptw100.AppZero.Application.Shared' } & DiscreteNumericListDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DiscreteNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & DiscreteNumericValueDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.FaultyNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & FaultyNumericValueDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericListDto, Ptw.Ptw100.AppZero.Application.Shared' } & NumericListDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & NumericValueDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & TextValueDto;


export function ISingleSystemSetupParameterFromJSON(json: any): ISingleSystemSetupParameter {
    return ISingleSystemSetupParameterFromJSONTyped(json, false);
}

export function ISingleSystemSetupParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISingleSystemSetupParameter {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, EnumerationValueDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, EnumerationValueListDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DiscreteNumericListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, DiscreteNumericListDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DiscreteNumericListDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DiscreteNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, DiscreteNumericValueDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DiscreteNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.FaultyNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, FaultyNumericValueDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.FaultyNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, NumericListDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericListDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, NumericValueDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericValueDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TextValueDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of ISingleSystemSetupParameter exists with '$type=${json['$type']}'`);
    }
}

export function ISingleSystemSetupParameterToJSON(value?: ISingleSystemSetupParameter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return EnumerationValueDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return EnumerationValueListDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DiscreteNumericListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return DiscreteNumericListDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DiscreteNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return DiscreteNumericValueDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.FaultyNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return FaultyNumericValueDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return NumericListDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return NumericValueDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TextValueDtoToJSON(value);
        default:
            throw new Error(`No variant of ISingleSystemSetupParameter exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the ISingleSystemSetupParameter interface.
 */
export function instanceOfISingleSystemSetupParameter(value: any): value is ISingleSystemSetupParameter {
    if (instanceOfEnumerationValueDto(value)) return true;
    if (instanceOfEnumerationValueListDto(value)) return true;
    if (instanceOfDiscreteNumericListDto(value)) return true;
    if (instanceOfDiscreteNumericValueDto(value)) return true;
    if (instanceOfFaultyNumericValueDto(value)) return true;
    if (instanceOfNumericListDto(value)) return true;
    if (instanceOfNumericValueDto(value)) return true;
    if (instanceOfTextValueDto(value)) return true;
    return false;
}

